// extracted by mini-css-extract-plugin
export default {"V2FormInputNumber":"V2FormInputNumber--Ca0qf"};